import React, { Component } from "react"
import styled, { createGlobalStyle } from "styled-components"
import paleta from '../img/paleta.svg'

const GlobalStyle = createGlobalStyle`
    body {
        transition: background 0s cubic-bezier(0,0,0,1);
        &[data-theme='dark'] {
            color: ${props => props.darkTextColor};
            background: ${props => props.darkColor};
        }
        &[data-theme='light'] {
            color: ${props => props.lightTextColor};
            background: ${props => props.lightColor};
        }
    }
`;

const ThemeSwitcherWrapper = styled.div`
	display: block;
`;

class ThemeSwitcher extends Component {
	constructor(props) {
		super(props);
		this.state = {
			theme:
				( typeof localStorage != "undefined" && localStorage.getItem("theme") !== null )
					? localStorage.getItem("theme")
					: "light"
		};
	}
	componentDidMount = () => {
		const { theme } = this.state;
		const { cssSelector } = this.props;
		const seletor = document.querySelector(cssSelector);
		seletor.dataset.theme = theme;
	};

	switchTheme = () => {
		const { cssSelector } = this.props;
		const seletor = document.querySelector(cssSelector);

		this.setState(
			currentState => ({
				theme: currentState.theme === "light" ? "dark" : "light"
			}),
			() => {
				seletor.dataset.theme = this.state.theme;
				localStorage.setItem("theme", this.state.theme);
			}
		);
	};

	render() {
		const { theme } = this.state;
		const {
			darkColor,
			lightColor,
			darkTextColor,
			lightTextColor
		} = this.props;
		return (
			<ThemeSwitcherWrapper>
				<GlobalStyle
					darkColor={darkColor}
					lightColor={lightColor}
					darkTextColor={darkTextColor}
					lightTextColor={lightTextColor}
				/>
				<img src={paleta} onClick={this.switchTheme} className="page-header-color" alt="Izbor boje teme" />
			</ThemeSwitcherWrapper>
		);
	}
}

ThemeSwitcher.defaultProps = {
	cssSelector: "body",
	darkColor: "#282c34!important",
	lightColor: "#ffffff!important",
	lightTextColor: "#272b33!important",
	darkTextColor: "#ffffff!important"
};

export default ThemeSwitcher;